import { Link } from "react-router-dom";
import "./footer.css";

export const Footer = (props) => {
  return (
    <div className="debug footer">
      <div className="navi">
        <div className="item">
          <Link to="service.doc.html">服务条款</Link>
        </div>

        <div className="item">
          <Link to="privacy.doc.html">隐私声明</Link>
        </div>

        <div className="item">
          <Link to="community.doc.html">社区规范</Link>
        </div>

        <div className="item">
          <Link to="rule.doc.html">发帖准则</Link>
        </div>
      </div>
      <div class="footer2">
        <div class="footerBox">
          <p>
            COPYRIGHT © 2022Enmoli Inc. ALL RIGHTS RESERVED
            <a
              href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=45010302003008"
              target="_blank"
            >
              <img src="./img/footer.png" alt="" width="25" />
              {/* 公安备案：45010302003008 */}
            </a>
            不良信息举报中心 网络110报警服务
          </p>
          <p>

            <a target="_blank" href="https://beian.miit.gov.cn/">
            豫ICP备2020030221号-1
            </a>
            河南逗趣网络科技有限公司
          </p>
          <p>
            地址：河南自贸试验区郑州片区(郑东)金水东路88号楷林IFC1号楼20层2022号
          </p>
        </div>
      </div>
    </div>
  );
};
